import { fillArr, randomNum } from '@hglobal/common';
import { FinancialRequestHistoryItemType, FinancialRequestStatus } from '@pt/models';
import { environment } from '@pt/environment';

import { GetRequestDetailsRes } from '../models';

export function getRequestDetailsMock(id: number): GetRequestDetailsRes {
  return {
    request: {
      requestId: id,
      userStaffKey: 'STAF-198712',
      userTelegramUsername: '@a.sidorov',
      userSlackId: id.toString(),
      requestIdHash: id.toString(),
      requestType: ['message', 'updatePaymentMethod'][randomNum(1)],
      category: [
        'I did not receive my salary payment',
        'I need clarification regarding my salary',
        'I have a question regarding my bonus payment',
      ][randomNum(1)],
      location: ['Ukraine', 'Poland'][randomNum(1, 0)],
      user: {
        id,
        fullName: 'Aleksander Sidorov',
        imageUrl: '',
        position: 'mock',
        email: 'test@test',
      },
      createdAt: new Date(),
      date: new Date(),
      status: [
        FinancialRequestStatus.New,
        FinancialRequestStatus.InProgress,
        FinancialRequestStatus.Completed,
        FinancialRequestStatus.Rejected,
        FinancialRequestStatus.Canceled,
      ][randomNum(4)],
      files: [
        `${environment.assetsHost}/assets/files/file.pdf`,
        `${environment.assetsHost}/assets/images/mock-article.png`,
      ],
      history: fillArr(randomNum(id, 1), i => ({
        status: [
          FinancialRequestStatus.New,
          FinancialRequestStatus.InProgress,
          FinancialRequestStatus.Completed,
          FinancialRequestStatus.Rejected,
          FinancialRequestStatus.Canceled,
        ][randomNum(4)],
        createdAt: new Date(),
        eventType: FinancialRequestHistoryItemType.Assignee,
        historyInfo: 'mock',
      })),
    },
  };
}
